import {
  ProcurementPurchaseOrderResponse,
  ProcurementPurchaseOrderItemResponse,
  ProcurementPurchaseOrderItemRequest,
  ProcurementPurchaseOrderPageRequest,
  ProcurementPurchaseOrderPageResponse,
  ProcurementPurchaseOrderRequest,
  ProcurementPurchaseOrderTypeResponse,
  ProcurementPurchaseOrderUpdateRequest,
} from "lib-klab-sdks";
import {
  PurchaseOrder,
  PurchaseOrderItem,
  PurchaseOrderItemRequest,
  PurchaseOrderPage,
  PurchaseOrderPageRequest,
  PurchaseOrderRequest,
  PurchaseOrderType,
  PurchaseOrderUpdateRequest,
} from "../../../domain/models/procurement/purchase-order.model";

export function mapPurchaseOrderType(source: ProcurementPurchaseOrderTypeResponse): PurchaseOrderType {
  return { id: source.id, code: source.code, name: source.name, description: source.description, active: source.active };
}

export function mapPurchaseOrderItem(source: ProcurementPurchaseOrderItemResponse): PurchaseOrderItem {
  return {
    id: source.id,
    purchaseOrderId: source.purchaseOrderId,
    productName: source.productName,
    unitOfMeasure: source.unitOfMeasure,
    quantity: source.quantity,
    unitPrice: source.unitPrice,
    subtotal: source.subtotal,
    igvAmount: source.igvAmount,
    totalPrice: source.totalPrice,
    currencyId: source.currencyId,
    itemOrder: source.itemOrder,
    createdAt: source.createdAt,
  };
}

export function mapPurchaseOrder(source: ProcurementPurchaseOrderResponse): PurchaseOrder {
  return {
    id: source.id,
    orderNumber: source.orderNumber,
    orderTypeId: source.orderTypeId,
    orderType: source.orderType,
    companyId: source.companyId,
    company: source.company,
    supplierId: source.supplierId,
    supplier: source.supplier,
    statusId: source.statusId,
    status: source.status,
    currencyId: source.currencyId,
    subtotal: source.subtotal,
    igvAmount: source.igvAmount,
    totalAmount: source.totalAmount,
    shippingAmount: source.shippingAmount ?? 0,
    otherAmount: source.otherAmount ?? 0,
    issueDate: source.issueDate,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
    observations: source.observations,
    createdBy: source.createdBy,
    contactPerson: source.contactPerson,
    contactEmail: source.contactEmail,
    contactPhone: source.contactPhone,
    deliveryAddress: source.deliveryAddress,
    receivingPerson: source.receivingPerson,
    shippingMethod: source.shippingMethod,
    requestingArea: source.requestingArea,
    shippingConditions: source.shippingConditions,
    serviceStartDate: source.serviceStartDate,
    serviceEndDate: source.serviceEndDate,
    serviceModality: source.serviceModality,
    items: source.items.map(mapPurchaseOrderItem),
  };
}

export function mapPurchaseOrderRequest(request: PurchaseOrderRequest): ProcurementPurchaseOrderRequest {
  return {
    orderTypeId: request.orderTypeId,
    companyId: request.companyId,
    supplierId: request.supplierId,
    statusId: request.statusId,
    currencyId: request.currencyId,
    ...(request.issueDate !== undefined ? { issueDate: request.issueDate } : {}),
    observations: request.observations,
    createdBy: request.createdBy,
    shippingAmount: request.shippingAmount,
    otherAmount: request.otherAmount,
    contactPerson: request.contactPerson,
    contactEmail: request.contactEmail,
    contactPhone: request.contactPhone,
    deliveryAddress: request.deliveryAddress,
    receivingPerson: request.receivingPerson,
    shippingMethod: request.shippingMethod,
    requestingArea: request.requestingArea,
    shippingConditions: request.shippingConditions,
    serviceStartDate: request.serviceStartDate,
    serviceEndDate: request.serviceEndDate,
    serviceModality: request.serviceModality,
    items: request.items.map(mapPurchaseOrderItemRequest),
  };
}

export function mapPurchaseOrderUpdateRequest(request: PurchaseOrderUpdateRequest): ProcurementPurchaseOrderUpdateRequest {
  return {
    orderTypeId: request.orderTypeId,
    supplierId: request.supplierId,
    statusId: request.statusId,
    currencyId: request.currencyId,
    issueDate: request.issueDate,
    observations: request.observations,
    shippingAmount: request.shippingAmount,
    otherAmount: request.otherAmount,
    contactPerson: request.contactPerson,
    contactEmail: request.contactEmail,
    contactPhone: request.contactPhone,
    deliveryAddress: request.deliveryAddress,
    receivingPerson: request.receivingPerson,
    shippingMethod: request.shippingMethod,
    requestingArea: request.requestingArea,
    shippingConditions: request.shippingConditions,
    serviceStartDate: request.serviceStartDate,
    serviceEndDate: request.serviceEndDate,
    serviceModality: request.serviceModality,
    items: request.items?.map(mapPurchaseOrderItemRequest),
  };
}

export function mapPurchaseOrderPageRequest(request: PurchaseOrderPageRequest): ProcurementPurchaseOrderPageRequest {
  return {
    page: request.page,
    size: request.size,
    search: request.search,
    date: request.date,
    startDate: request.startDate,
    endDate: request.endDate,
    orderTypeId: request.orderTypeId,
    companyId: request.companyId,
  };
}

export function mapPurchaseOrderPage(response: ProcurementPurchaseOrderPageResponse): PurchaseOrderPage {
  return {
    content: response.content.map(mapPurchaseOrder),
    page: response.page,
    size: response.size,
    totalElements: response.totalElements,
    totalPages: response.totalPages,
  };
}

function mapPurchaseOrderItemRequest(item: PurchaseOrderItemRequest): ProcurementPurchaseOrderItemRequest {
  return {
    productName: item.productName,
    unitOfMeasure: item.unitOfMeasure,
    quantity: item.quantity,
    unitPrice: item.unitPrice,
    subtotal: item.subtotal,
    igvAmount: item.igvAmount,
    totalPrice: item.totalPrice,
    currencyId: item.currencyId,
    itemOrder: item.itemOrder,
  };
}
